import { callAppAPI } from "./AppApiClient";
import { DictionnaireApi } from "./DictionnaireApi";
import { User } from "src/domain/User";


export const fetchMenu = async (uuidEmployeur?: string, noTiers?: string) => {
  return callAppAPI<User>({
    method: "GET",
    url: DictionnaireApi.menu.getUrl(),
    params: { uuidEmployeur, noTiers }
  })
    .then(result => {
      return result;
    })
    .catch(err => {
      console.log("user non connecté. Error : " + err);
      return null;
    });
};
